import { render, staticRenderFns } from "./kdQualityManagerUpgradeAudit.vue?vue&type=template&id=ef034b94&scoped=true"
import script from "./kdQualityManagerUpgradeAudit.vue?vue&type=script&setup=true&lang=js"
export * from "./kdQualityManagerUpgradeAudit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef034b94",
  null
  
)

export default component.exports